<template>
  <div>
    <h3>Logo</h3>
    <div class="form-component">
      <UploadOneImage :image="{ src: $parent.pageFixedSettings.footer.settings.logo }" @callback="getImageDeskTop" />
    </div>
    <label for="">Height desktop</label>
    <v-text-field
      v-model="$parent.pageFixedSettings.footer.settings.size_logo.desktop"
      @input="$parent.changeConfig()"
    ></v-text-field>
    <label for="">Height mobile</label>
    <v-text-field
      v-model="$parent.pageFixedSettings.footer.settings.size_logo.mobile"
      @input="$parent.changeConfig()"
    ></v-text-field>
    <v-divider class="mb-4"></v-divider>
    <div v-if="$parent.pageFixedSettings.footer.settings.infoWithIcon">
      <div class="d-flex align-center justify-space-between">
        <h4>Info icons</h4>
        <v-btn color="primary" text @click="addContentInfo" small><v-icon left>mdi-plus</v-icon> Add Info</v-btn>
      </div>
      <v-expansion-panels accordion class="list-section" style="max-height:1100px !important">
        <draggable
          v-model="$parent.pageFixedSettings.footer.settings.infoWithIcon"
          @change="change"
          style="width: 100%;"
        >
          <transition-group>
            <v-expansion-panel
              v-for="(item, i) in $parent.pageFixedSettings.footer.settings.infoWithIcon"
              :key="`item${i}`"
            >
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
                <i class="fas fa-bars mr-2" style="flex:none !important"></i>

                {{ 'Info Icon' }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <UploadOneImage :itemSetData="item" :image="{ src: item.icon }" @callback="getImageIcon" />
                <label class="mt-5 d-inline-block" for="">Title</label>
                <editor-new v-model="item.title" title="Title" />
                <editor-new v-model="item.subTitle" title="Sub Title" />
                <!-- <v-text-field height="auto" v-model="item.subTitle" @input="$parent.changeConfig"></v-text-field> -->
                <div class="mt-2">
                  <span class="pointer font-weight-bold red--text" @click="removeContentInfo(i)">
                    Remove Info
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </transition-group>
        </draggable>
      </v-expansion-panels>
    </div>
    <v-divider class="my-4"></v-divider>
    <editor-new-noedit v-model="$parent.pageFixedSettings.footer.settings.info" title="Information" />
    <v-divider class="my-4"></v-divider>
    <div class="d-flex align-center justify-space-between">
      <h4>Main Menu</h4>
      <v-btn color="primary" text small @click="$router.push({ name: 'website.menus' })">Edit Menu</v-btn>
    </div>
    <v-select
      v-model="$parent.pageFixedSettings.footer.settings.footer_menu"
      :items="$parent.mainMenu"
      @input="$parent.changeConfig('menuFooter', 0)"
      item-text="title"
      item-value="id"
    ></v-select>

    <v-divider class="my-4"></v-divider>
    <editor-new-noedit v-model="$parent.pageFixedSettings.footer.settings.certificates" title="Certificates" />
    <v-divider class="my-4"></v-divider>
    <h4>Social Link</h4>
    <p>Facebook</p>
    <v-text-field
      v-model="$parent.pageFixedSettings.footer.settings.link_social.facebook"
      height="auto"
      @input="$parent.changeConfig"
    ></v-text-field>
    <p>Trustpilot</p>
    <v-text-field
      v-model="$parent.pageFixedSettings.footer.settings.link_social.trustpilot"
      height="auto"
      @input="$parent.changeConfig"
    ></v-text-field>
    <p>Instagram</p>
    <v-text-field
      v-model="$parent.pageFixedSettings.footer.settings.link_social.instagram"
      height="auto"
      @input="$parent.changeConfig"
    ></v-text-field>
    <v-divider class="my-4"></v-divider>
    <v-checkbox
      @change="$parent.changeConfig"
      v-model="$parent.pageFixedSettings.footer.settings.show_contact_form"
      label="Show contact form"
      class="option-checkbox-height"
    ></v-checkbox>
    <v-divider class="my-4"></v-divider>
    <div v-if="$parent.pageFixedSettings.footer.settings.iconPayments">
      <div class="d-flex align-center justify-space-between mb-2">
        <h4>Payments</h4>
        <v-btn color="primary" text @click="addContent" small><v-icon small left>mdi-plus</v-icon> Add </v-btn>
      </div>
      <v-expansion-panels accordion class="list-section" style="max-height: 1100px !important">
        <draggable
          v-model="$parent.pageFixedSettings.footer.settings.iconPayments"
          @change="change"
          style="width: 100%;"
        >
          <transition-group>
            <v-expansion-panel
              v-for="(item, i) in $parent.pageFixedSettings.footer.settings.iconPayments"
              :key="`item${i}`"
            >
              <v-expansion-panel-header expand-icon="mdi-menu-down" class="heading">
                <i class="fas fa-bars mr-2" style="flex:none !important"></i>
                {{ 'Payment Icon' }}</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <UploadOneImage :itemSetData="item" :image="{ src: item.value }" @callback="getImage" />
                <div class="mt-2">
                  <span class="pointer font-weight-bold red--text" @click="removeContent(i)">
                    Remove icon
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </transition-group>
        </draggable>
      </v-expansion-panels>
    </div>
    <v-divider class="my-4"></v-divider>
    <editor-custom
      :content.sync="$parent.pageFixedSettings.footer.settings.copyright"
      :title="`Copyright`"
      @change="$parent.changeConfig()"
      height="500px"
    ></editor-custom>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import EditorCustom from '../driver-theme64/EditorCustom.vue';
import EditorNew from '../EditorNew.vue';
import EditorNewNoedit from '../EditorNewNoedit.vue';

export default {
  components: {
    EditorCustom,
    draggable,
    EditorNew,
    EditorNewNoedit,
  },
  methods: {
    getImageDeskTop(image) {
      this.$parent.pageFixedSettings.footer.settings.logo = image.src;
      this.$parent.changeConfig('menu', 0);
    },
    getImage(images, item) {
      item.value = images.src;
      this.$parent.changeConfig();
      //   this.attributes.image = images;
    },
    getImageIcon(images, item) {
      item.icon = images.src;
      this.$parent.changeConfig();
      //   this.attributes.image = images;
    },
    removeContent(i) {
      this.$parent.pageFixedSettings.footer.settings.iconPayments.splice(i, 1);
      this.$parent.changeConfig();
    },
    change() {
      this.$parent.changeConfig();
    },
    addContent() {
      this.$parent.pageFixedSettings.footer.settings.iconPayments.push({
        value: null,
      });
    },
    removeContentInfo(i) {
      this.$parent.pageFixedSettings.footer.settings.infoWithIcon.splice(i, 1);
      this.$parent.changeConfig();
    },

    addContentInfo() {
      this.$parent.pageFixedSettings.footer.settings.infoWithIcon.push({
        icon: null,
        title: 'High-quality Goods',
        subTitle: 'Enjoy top quality items for less',
      });
      this.$parent.changeConfig();
    },
  },
};
</script>

<style lang="scss" scoped></style>
